import { uiFb } from '@/lib/i18n';
import { HOMEPAGE_FAQS } from '@/lib/seo/homepage-faqs';

export function HomepageFaq({ lang = 'en' }: { lang?: string }) {
  return (
    <section
      id="homepage-faq"
      aria-label={uiFb('ui.faq.heading', 'Frequently asked questions', lang)}
      className="px-4 py-10 md:px-8 lg:px-16 xl:px-20"
    >
      <div className="mx-auto max-w-3xl">
        <h2 className="mb-6 text-center font-heading text-2xl font-bold tracking-tight text-text-primary md:text-3xl">
          {uiFb('ui.faq.heading', 'Frequently asked questions', lang)}
        </h2>
        <div className="divide-y divide-border-subtle rounded-xl border border-border-subtle bg-surface-card">
          {HOMEPAGE_FAQS.map((f) => (
            <details key={f.questionKey} className="group p-5">
              <summary className="flex cursor-pointer items-center justify-between gap-3 font-heading text-base font-semibold text-text-primary marker:hidden">
                {uiFb(f.questionKey, f.questionFallback, lang)}
                <span aria-hidden="true" className="text-muted transition-transform group-open:rotate-180">▾</span>
              </summary>
              <p className="mt-3 text-sm leading-relaxed text-text-secondary">
                {uiFb(f.answerKey, f.answerFallback, lang)}
              </p>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}
